<template>
  <div class="accout-login">
    <a-form
      :form="form"
      @submit.prevent="loginHandle"
    >
      <a-form-item
        label=""
      >
        <a-input
          v-decorator="decorators.username"
          :placeholder="accountTitTxt"
        />
      </a-form-item>
      <a-form-item
        label=""
        class="password-box"
      >
        <a-input
          v-decorator="decorators.password"
          :placeholder="longinPwdTitTxt"
          class="password-input"
          type="password"
        />
        <router-link
          :to="{ name: 'AccountFindPwd' }"
          class="find-pwd-link"
        >
          {{ $t('message["1573"]') }}
        </router-link>
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
        >
          {{ $t('message["196"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import loginMin from '@/store/account/loginMin'
export default {
  mixins: [loginMin],
  data () {
    return {
      formLayout: 'horizontal'
    }
  },
  computed: {
    ...mapState('account/login', ['submitting', 'decorators']),
    longinPwdTitTxt () {
      return this.$t('message["198"]')
    },
    accountTitTxt () {
      return this.$t('message["203"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('account/login', ['login', 'toOrgProject']),
    loginHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, { logintype: 1 })
          const chain = await this.login()
          chain.params(obj)
            .onSuccess(async (raw) => {
              const chain2 = await this.toOrgProject()
              chain2.onSuccess(res => {
                this.getOrgPro(res)
              })
            })
            .setForm(this.form)
            .fetch()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .accout-login::v-deep {
    .login-btn {
      display: block;
      width: 100%;
    }

    .password-box  {
      position: relative;
      overflow: hidden;

      .ant-form-item-children {
        display: inline-block;
        .ant-input{
          padding-right: 75px;
        }
      }

      .find-pwd-link {
        position: absolute;
        right: 12px;
        top: 1px;
        // line-height: 32px;
      }
    }
  }
</style>
